<script setup>
import { computed, onMounted, getCurrentInstance } from 'vue';
import Button from "./Button.vue";

const props = defineProps({
    contentTypeId: Number,
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const router = proxy.$router;

// --- Computed ---

const contentType = computed(() => {
    return store.getters['templates/contentTypes']?.find(o => o.id === props.contentTypeId);
});

const contentTypeTitle = computed(() => {
    return contentType.value?.title;
});

const contentTypeLabel = computed(() => {
    const type = contentType.value?.contentType;

    // Safety check: ensure type exists before calling toLowerCase()
    if (type && type.toLowerCase() !== 'basic') {
        return type;
    }

    return '';
});

const hasEditAccess = computed(() => {
    return store.getters['user/access']('templates_templates', 'edit');
});

// --- Methods ---

const gotToThemesEditor = () => {
    router.push({
        name: 'themesEditor',
        query: {
            section: 'content_types',
            id: props.contentTypeId
        }
    });
};

// --- Lifecycle ---

onMounted(() => {
    // Ensure the templates store is initialized to populate getters
    store.dispatch('templates/init');
});
</script>

<template>
    <Button
        class="btn-sm p-0 px-1"
        :disabled="!hasEditAccess"
        @click.native="gotToThemesEditor"
    >
        {{ contentTypeTitle }}<span v-if="contentTypeLabel"> - {{ contentTypeLabel }}</span>
    </Button>
</template>